export default __webpack_public_path__ + "static/media/customer-list-dark.d1dba981.svg";